export function saveColumnsNegotaitionsQualityAgent(columns) {
  return {
    type: "CHANGE_COLUMNS_NEGOTIATIONS_QUALITY_AGENT",
    name: columns.name,
    nps: columns.nps,
    csat: columns.csat,
  };
}
